module.exports = __webpack_public_path__ + "img/SA.4a3b41b8.webp";